import React from 'react'
import Social from '../Social/Social'

function Footer() {
  return (
    <div className='h-[100px] w-full bg-[#7FBABB]'>
        <div className='flex justify-center items-center h-[100%]'><Social/></div>
    </div>
  )
}

export default Footer